import { useApiClient } from '~/api-client';
import { useMutation } from '@tanstack/react-query';
import { DexArticleFormBootstrapView, SingleArticleInquiry } from '@mark43/cad-api';
import { DexQueriessubmitResource, DexQuerySubmissionSingleArticleInquiry } from '@mark43/dex-api';
import { useForm } from 'react-hook-form';
import { DexForm } from './dex-form';
import { DexFormModel } from '../types';
import { pruneDexFields } from '../utils';
import { useIsLinkToAssignedEventCheckboxVisible } from './use-is-link-to-assigned-even-visible';
import { EventWorkspacePanelDexFormPrefill } from '../../panels/workspace-panel-types';
import { useBuildDexQuerySubmission } from './use-build-dex-query-submission';
import { useResetValuesAfterOriAliasChange } from './use-reset-values-after-ori-alias-change';
import { useResetDexFormOnPrefillValuesUpdate } from './use-reset-dex-form-on-prefill-values-update';

export function DexArticleForm({
    formBootstrapView,
    dexFormEventPanelPrefillValues,
}: {
    formBootstrapView: DexArticleFormBootstrapView;
    dexFormEventPanelPrefillValues?: EventWorkspacePanelDexFormPrefill;
}): React.ReactElement {
    const apiClient = useApiClient();
    const isLinkToAssignedEventCheckboxVisible = useIsLinkToAssignedEventCheckboxVisible();
    const defaultValues = {
        params: {
            ...formBootstrapView.defaultValues,
            ...(pruneDexFields(formBootstrapView, dexFormEventPanelPrefillValues?.article) ?? {}),
        },
        requestingUnitOption: null,
        agencyEventOption: null,
        ...(isLinkToAssignedEventCheckboxVisible ? { linkToAssignedEvent: true } : null),
    };
    const form = useForm<DexFormModel<SingleArticleInquiry>>({
        mode: 'onBlur',
        defaultValues,
    });

    useResetValuesAfterOriAliasChange({
        formInitalValues: formBootstrapView.defaultValues,
        form,
        defaultValues,
    });

    useResetDexFormOnPrefillValuesUpdate({
        form,
        prefillValues: dexFormEventPanelPrefillValues?.article,
    });

    const buildDexQuerySubmission = useBuildDexQuerySubmission(
        form,
        formBootstrapView.dexFormView.dexQuery
    );
    const sendQueryMutation = useMutation((formModel: DexFormModel<SingleArticleInquiry>) => {
        return apiClient.request<DexQueriessubmitResource.SubmitArticleQuery>({
            service: 'DEX',
            method: 'POST',
            url: 'dex_queries/submit/single_article_inquiry',
            data: buildDexQuerySubmission(formModel) as DexQuerySubmissionSingleArticleInquiry,
        });
    });
    return (
        <DexForm
            eventNumber={dexFormEventPanelPrefillValues?.eventNumber}
            dexFormView={formBootstrapView.dexFormView}
            defaultParams={formBootstrapView.defaultValues}
            form={form}
            sendQueryMutation={sendQueryMutation}
        />
    );
}
